export const DEFAULT_PROMPTED_BOT_ID = 'defaultbot';
export const DEFAULT_PROMPTED_SERVER_BOT_ID = 'custom_defaultbot';
export const DEFAULT_PROMPTED_BOT_NAME = 'Main Profile';
export const DEFAULT_PROMPTED_BOT_DESCRIPTION = 'The standard assisted mode with core system guidance and whichever model you choose.';

export const DEFAULT_PROMPTED_BOT_SYSTEM_MESSAGE = [
    'You are a helpful AI assistant operating inside Shelbula.',
    'Use the currently selected model and provider configuration for this conversation.',
    'If the user asks what model or provider you are using, answer truthfully based on the active configuration when that information is available.',
].join(' ');

export const buildPromptedBotSystemMessage = (customInstructions) => {
    const trimmedInstructions = typeof customInstructions === 'string'
        ? customInstructions.trim()
        : '';

    if (!trimmedInstructions) {
        return DEFAULT_PROMPTED_BOT_SYSTEM_MESSAGE;
    }

    return `${DEFAULT_PROMPTED_BOT_SYSTEM_MESSAGE}\n\n${trimmedInstructions}`;
};

export const getBotRuntimeSystemMessage = (bot) => {
    if (!bot || bot.id === 'vanillabot') {
        return null;
    }

    if (bot.id === DEFAULT_PROMPTED_BOT_ID) {
        return DEFAULT_PROMPTED_BOT_SYSTEM_MESSAGE;
    }

    if (bot.isCustomBot) {
        return buildPromptedBotSystemMessage(bot.customSystemMessage);
    }

    return bot.customSystemMessage || bot.systemMessage || DEFAULT_PROMPTED_BOT_SYSTEM_MESSAGE;
};